import React, { Component } from 'react';
import { getFriendlyNameForAlertLevel } from '../../services/AlertLevel';
import { SeverityLevel } from '../severity-level/SeverityLevel';

class AlertLevel extends Component {
    render() {
        return (
            <SeverityLevel
                text={getFriendlyNameForAlertLevel(this.props.level)}
                level={this.props.level}
            />
        );
    }
}

export default AlertLevel;
